import APIService from "@/services/APIService.js";

export const namespaced = true;

export const state = {
  links: [],
  groups: [],
  assignees: [],
  currentUrl: "",
  counts: {
    myNew: 0,
    allNew: 0,
    review: 0,
    disavowed: 0,
    approved: 0,
  },
  fetchGroupsConfig: {
    project_id: null,
    disavow_status: null,
    limit: 25,
    orderBy: "id",
    orderDir: "asc",
    before_id: null,
    after_id: null,
    assigned: true,
    page: 1,
  },
  prev_page: false,
  next_page: false,
  headers: [
    {
      text: "ID",
      value: "id",
      filterType: "integer",
      ruleType: false,
    },
    {
      text: "Group Status",
      value: "status",
      filterType: "status",
      ruleType: false,
    },
    {
      text: "Group",
      value: "group",
      filterType: "string",
      ruleType: true,
    },
    {
      text: "GroupType",
      value: "type",
      filterType: "string",
      ruleType: true,
    },
    {
      text: "links",
      value: "num_links",
      filterType: "string",
      ruleType: true,
    },
    {
      text: "Extension",
      value: "extension",
      filterType: "string",
      ruleType: true,
    },
    {
      text: "Assignee",
      value: "assignee_id",
      filterType: "string",
      ruleType: false,
    },
    {
      text: "Created",
      value: "created_at",
      filterType: "date",
      ruleType: true,
    },
    {
      text: "Updated",
      value: "updated_at",
      filterType: "date",
      ruleType: true,
    },
    {
      text: "Updated by",
      value: "updated_by",
      filterType: "string",
      ruleType: false,
    },
  ],
  innerHeaders: [
    {
      text: "Link Status",
      value: "disavow_status",
      filterType: false,
      ruleType: false,
      sortable: false,
    },
    { text: "ID", value: "id", filterType: false, ruleType: false },
    { text: "Link", value: "url", filterType: "string", ruleType: true },
    {
      text: "Anchor Text",
      value: "anchor_text",
      filterType: "string",
      ruleType: false,
    },
    {
      text: "Pre Text",
      value: "pre_text",
      filterType: "string",
      ruleType: false,
    },
    {
      text: "Title Tag",
      value: "title_tag",
      filterType: "string",
      ruleType: false,
    },
    {
      text: "Page Topic",
      value: "page_topic",
      filterType: "string",
      ruleType: false,
    },
  ],
};

export const mutations = {
  SET_GROUPS(state, data) {
    state.groups = data;
  },
  SET_LINKS(state, data) {
    state.links = data;
  },
  SET_PREV(state, status) {
    state.prev_page = status;
  },
  SET_NEXT(state, status) {
    state.next_page = status;
  },
  SET_COUNTS(state, counts) {
    state.counts = counts;
  },
  SET_DOMAIN_LINKS(state, data) {
    state.domainLinks = data;
  },
  SET_ASSIGNEES(state, data) {
    state.assignees = data;
  },
  SET_CURRENT_URL(state, data) {
    console.log(data);
    state.currentUrl = data;
  },
  SET_CURRENT_SORT_AND_DIR(state, data) {
    state.currentSortAndDir = data;
  },

  SET_FETCH_GROUPS_CONFIG(state, data) {
    //state.fetchGroupsConfig = data;
    console.log(data);
  },
};

export const actions = {
  setCurrentUrl({ commit }, data) {
    commit("SET_CURRENT_URL", data);
  },

  setCurrentSortAndDir({ commit }, data) {
    console.log("--ORDER AND DIR FLAG ---");
    console.log(data);
    commit("SET_CURRENT_SORT_AND_DIR", data);
  },

  setFetchGroupsConfig({ commit }, data) {
    commit("SET_FETCH_GROUPS_CONFIG", data);
  },
  clearLinks({ commit }) {
    commit("SET_LINKS", []);
  },
  setLinks({ commit }, data) {
    commit("SET_LINKS", data);
  },
  setGroups({ commit }, data) {
    commit("SET_GROUPS", data);
  },
  fetchLinks({ commit, dispatch }, { config }) {
    if (config.project_id) {
      console.log(config);
      config.limit = 3000;
      return APIService.getLinks(config)
        .then((response) => {
          console.log(response.data.results);
          commit("SET_LINKS", response.data.results);
        })
        .catch((error) => {
          const notification = {
            type: "error",
            message: "Error fetching links",
          };
          console.log(error);
          dispatch("notification/add", notification, { root: true });

          commit("SET_LINKS", []);
          console.log(error);
        });
    } else {
      return false;
    }
  },
  fetchGroups({ commit, dispatch }, { config }) {
    console.log(state.currentUrl.params);

    if (state.currentUrl.params) {
      config.urlStatus = state.currentUrl.params.status;
    } else {
      config.urlStatus = state.currentUrl.status;
    }

    console.log(state.currentUrl);

    console.log(config);
    if (config.project_id) {
      return APIService.getGroups(config)
        .then((response) => {
          console.log(response);
          console.log(config);

          commit("SET_GROUPS", response.data.results);
          let assignees = [];
          for (let i = 0; i < response.data.results.length; i++) {
            assignees[i] = response.data.results[i].assignee_id;
          }
          commit("SET_ASSIGNEES", assignees);
          commit("SET_PREV", response.data.prev_page);
          commit("SET_NEXT", response.data.next_page);
          commit("SET_COUNTS", response.data.counts);
          console.log(response.data.results);

          let totalLinks = 0;
          for (let i = 0; i < response.data.results.length; i++) {
            totalLinks += response.data.results[i].num_links;
          }

          console.log(totalLinks);
        })
        .catch((error) => {
          const notification = {
            type: "error",
            message: "Error fetching links",
          };
          console.log(error);
          dispatch("notification/add", notification, { root: true });

          commit("SET_GROUPS", []);
          commit("SET_PREV", false);
          commit("SET_NEXT", false);
          console.log(error);
        });
    } else {
      return false;
    }
  },
};

export const getters = {
  headers: (state) => state.headers,
  innerHeaders: (state) => state.innerHeaders,
  counts: (state) => state.counts,
  currentUrl: (state) => state.currentUrl,
  fetchGroupsConfig: (state) => state.fetchGroupsConfig,
  currentSortAndDir: (state) => state.currentSortAndDir,
};
